import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_WS2: TStep[] = [
  {
    pageId: PageId.AGE_WS2,
  },
  {
    pageId: PageId.SEX_WS2,
  },
  {
    pageId: PageId.URGE_WS2,
  },
  {
    pageId: PageId.BREED_WS2,
  },
  {
    pageId: PageId.URGE_WS2_2,
  },
  {
    pageId: PageId.LICK_PAWS_WS2,
  },
  {
    pageId: PageId.DRAG_BOTTOM_WS2,
  },
  {
    pageId: PageId.CHECK_EARS_WS2,
  },
  {
    pageId: PageId.WASH_TEETH_WS2,
  },
  {
    pageId: PageId.CLEAN_EYES_WS2,
  },
  {
    pageId: PageId.BREATH_WS2,
  },
  {
    pageId: PageId.WEIGHT_WS2,
  },
  {
    pageId: PageId.FEED_WS2,
  },
  {
    pageId: PageId.FOOD_PORTIONS_WS2,
  },
  {
    pageId: PageId.URGE_WS2_4,
  },
  {
    pageId: PageId.WATER_WS2,
  },
  {
    pageId: PageId.CLEAN_BOWLS_WS2,
  },
  {
    pageId: PageId.COAT_WS2,
  },
  {
    pageId: PageId.WALK_WS2,
  },
  {
    pageId: PageId.URGE_WS2_5,
  },
  {
    pageId: PageId.VET_WS2,
  },
  {
    pageId: PageId.PROTECT_WS2,
  },
  {
    pageId: PageId.CHRONIC_WS2,
  },
  {
    pageId: PageId.BEHAVIOR_CHANGES_WS2,
  },
  {
    pageId: PageId.URGE_WS2_6,
  },
  {
    pageId: PageId.ITCH_WS2,
  },
  {
    pageId: PageId.DOG_NAME_WS2,
  },
  {
    pageId: PageId.SPEND_TIME_WS2,
  },
  {
    pageId: PageId.PREPARE_FLOW_WS2,
  },
  {
    pageId: PageId.EMAIL_WS2,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_WS2,
  },
  {
    pageId: PageId.GIFT_WS2,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_WS2,
  },
  {
    pageId: PageId.CANCEL_OFFER_WS2,
  },
  {
    pageId: PageId.CHAT_UPSELL_WS2,
  },
  {
    pageId: PageId.UPSELL_WS2,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_WS2,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_WS2.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_WS2.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
